export default class DarkModeSwitcher {
    constructor() {
        this.switchers = document.querySelectorAll('[data-mode-switcher]');
        this.containers = document.querySelectorAll('[data-mode-container]');

        if (this.switchers.length || this.containers.length) {
            this.mode = this.getCookie('mode') || 'light';

            this.switchers.forEach(switcher => {
                switcher.checked = this.mode === 'dark';
                switcher.addEventListener('change', () => {
                    this.toggleMode();
                });
            });

            this.updateContainersMode();
        }
    }

    static init() {
        if (document.querySelector('[data-mode-switcher]') || document.querySelector('[data-mode-container]')) {
            new DarkModeSwitcher();
        }
    }

    toggleMode() {
        this.mode = this.switchers[0].checked ? 'dark' : 'light';

        this.switchers.forEach(switcher => {
            switcher.checked = this.mode === 'dark';
        });

        this.setCookie('mode', this.mode, 365);
        this.updateContainersMode();
    }

    updateContainersMode() {
        this.containers.forEach(container => {
            if (this.mode === 'dark') {
                container.classList.add('mode-dark');
            } else {
                container.classList.remove('mode-dark');
            }
        });
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    setCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = `${name}=${value || ''}${expires}; path=/`;
    }
}
